import React, { useMemo, useCallback, memo } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import reactSelectOverWriteStyles from "./reactSelectOverWriteStyles";
import styles from "./PaginationConfig.module.scss";
import DropDown from "../../DropDown";

const PaginationConfig = ({ currentPage, countPerPage, total, handleChange, options, className, translate }) => {
  const start = (Math.min(currentPage, total) - 1) * countPerPage;
  let end = start + countPerPage;
  end = end > total ? total : end;
  const range = `${start + 1} - ${end}`;

  const text = total === 0 ? translate("No items") : translate("{{range}} of {{total}} items", { range, total });
  const selected = useMemo(() => options.find(option => option.value === countPerPage), [countPerPage]);
  const onChange = useCallback(option => handleChange(option.value), [handleChange]);

  return options[0].value < total ? (
    <div className={cn(styles.paginationConfig, className)}>
      <DropDown
        label={translate("Items per page")}
        labelPosition="left"
        options={options}
        value={selected}
        onChange={onChange}
        styles={reactSelectOverWriteStyles}
        className={styles.perPageSelect}
      />
      <span className={styles.paginationInfo}>{text}</span>
    </div>
  ) : null;
};

PaginationConfig.defaultProps = {
  className: "",
  options: [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" }
  ],
  translate: text => text
};

PaginationConfig.propTypes = {
  currentPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  countPerPage: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  translate: PropTypes.func,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  )
};

export default memo(PaginationConfig);
